import React, { useContext } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { ActionMenu } from "@/components";
import { useTextDomainContext } from "@/app/providers";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

type ShowItemsMap = Record<string, boolean>;

type MenuForType =
  | "user"
  | "system"
  | "partner"
  | "tenant"
  | "role"
  | "module"
  | "subscription"
  | "feature"
  | "company"
  | "data-limit"
  | "notification"
  | "document";

interface DataGridCellParams<TRow = Record<string, unknown>> {
  row: TRow;
}

export type MenuClickHandler<
  TAction = string,
  TRow extends object = Record<string, unknown>,
> = (action: TAction, row: TRow) => void;
export const DataGridActionsColumn = <
  TAction = string,
  TRow extends object = Record<string, unknown>,
>(
  showActionsColumn: boolean,
  menuFor: MenuForType,
  showItems: ShowItemsMap,
  menuClick?: MenuClickHandler<TAction, TRow>,
): Record<string, unknown>[] => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  return showActionsColumn
    ? [
        {
          field: "actions",
          type: "actions",
          hideable: false,
          maxWidth: 60,
          align: "right",
          headerAlign: "center",

          renderHeader: () => (
            <Tooltip title={gettext("Actions")}>
              <IconButton size="small" aria-label={gettext("Actions")}>
                <MoreHorizIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          ),

          renderCell: (params: DataGridCellParams<TRow>) => (
            <ActionMenu<TAction, TRow>
              menuFor={menuFor}
              row={params.row}
              showItems={showItems}
              menuClick={menuClick}
            />
          ),
        },
      ]
    : [];
};
